import { TButtonInstance } from 'widgets/global/Button';
import { TTabPanelChangeEvent } from 'widgets/global/Tabs';

function CoreTabsClassCreator(Tabs: import('widgets/global/Tabs').TTabs) {
    class CoreTabs extends Tabs {
        /**
         * @param panelName name of panel to activate
         * @param saveToPushState - If we need to save hash in history
         */
        activatePanel(panelName: string, saveToPushState = true) {
            if (!this.panelNames) {
                return;
            }

            const previousActivePanelName = this.activePanel;

            this.panelNames.forEach(id => {
                const isActive = id === panelName;

                const currentTabPanel = this.toggleTabPanel(id, isActive, saveToPushState);

                if (!currentTabPanel && this.ref(id)) {
                    this.toggleActiveRefPanel(this.ref(id), isActive);

                    if (isActive && saveToPushState) {
                        this.handleUrlAnchor(id);
                    }
                }

                if (isActive) {
                    this.activePanel = panelName;
                    this.focusedTab = panelName;

                    this.getById<TButtonInstance>(`button-${id}`, button => {
                        if (button.ref('self').get()?.hasAttribute('data-focus-content-id')) {
                            this.setFocusToContent(button);
                        }
                    });
                } else {
                    this.returnFocusToHandler(id);
                }

                this.toggleButton(id, isActive);
            });

            const eventData: TTabPanelChangeEvent = {
                activePanelName: panelName,
                previousActivePanelName
            };

            this.emit('panelactivated', eventData);
        }

        returnFocusToHandler(id: string | unknown) {
            setTimeout(() => {
                this.getById<TButtonInstance>(`button-${id}`, button => {
                    if (button.ref('self').get()?.hasAttribute('data-return-focus-to-self')) {
                        button.ref('self').focus();
                    }
                });
            }, 10);
        }

        handleSignInToBuyFormSubmit() {
            // no-op: overridden via data-forward-to-parent in sign-in-to-buy context
        }

        handleGTMUpdates() {
            // no-op: overridden via data-forward-to-parent in sign-in-to-buy context
        }
    }

    return CoreTabs;
}

export type TCoreTabs = ReturnType<typeof CoreTabsClassCreator>;

export type TSizeTabsInstance = InstanceType<TCoreTabs>;

export default CoreTabsClassCreator;
